import { render, staticRenderFns } from "./CooperadoCadastro.vue?vue&type=template&id=3aaecc30&scoped=true&"
import script from "./CooperadoCadastro.vue?vue&type=script&lang=js&"
export * from "./CooperadoCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaecc30",
  null
  
)

export default component.exports